"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const table_config_1 = require("@app/component/ui/table/table-config");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const _ui_1 = require("@ui");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const uuid_1 = require("uuid");
const DETAILS_CONTAINER_STYLE = {
    display: 'flex',
    width: '100%',
    gap: '0.25rem',
    alignItems: 'center',
};
const RecordsList = ({ records }) => {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const contractTypes = workspace?.contractTypes;
    const localities = workspace?.localities;
    const employees = (0, store_1.useRootSelector)((state) => state.employees);
    const positions = (0, store_1.useRootSelector)((state) => state.positions);
    const tableConfig = (0, table_config_1.createNullableTableConfig)([
        {
            key: 'userId',
            tlKey: 'WHO',
            sortable: records.length > 1,
            width: 150,
            maxWidth: 150,
            // filterable: records.length > 1,
            rowToHTML: (row) => {
                if (!Object.keys(employees).includes(row.userId || row.id))
                    return null;
                return employees[row.userId || row.id].name;
            },
            rowToStr: (row) => {
                if (!Object.keys(employees).includes(row.userId || row.id))
                    return '';
                return employees[row.userId || row.id].name;
            },
        },
        {
            key: 'date',
            tlKey: 'DATE',
            sortable: records.length > 1,
            // filterable: records.length > 1,
            width: 75,
            maxWidth: 75,
            minWidth: 75,
            rowToHTML: (row) => {
                if (!row.period)
                    return null;
                return react_1.default.createElement(react_1.default.Fragment, null, (0, moment_1.default)(row.period.start).format('D.M.'));
            },
            rowToStr: (row) => {
                if (!row.period)
                    return '';
                return (0, moment_1.default)(row.period.start).format('D.M.YYYY');
            },
        },
        {
            key: 'period',
            tlKey: 'TIME',
            sortable: records.length > 1,
            // filterable: records.length > 1,
            width: 120,
            maxWidth: 120,
            minWidth: 120,
            rowToHTML: (row) => {
                if (!row.period)
                    return null;
                return (react_1.default.createElement(react_1.default.Fragment, null, (0, moment_1.default)(row.period.start).format('HH:mm - ') +
                    (0, moment_1.default)(row.period.end).format('HH:mm')));
            },
            rowToStr: (row) => {
                if (!row.period)
                    return '';
                return (0, moment_1.default)(row.period.start).format('HH:mm');
            },
        },
        {
            key: 'detail',
            tlKey: 'MA_DETAIL',
            sortable: records.length > 1,
            // filterable: records.length > 1,
            rowToHTML: (row) => {
                const _contractType = row.contractType;
                const contractType = contractTypes?.find((type) => type.id === _contractType);
                const _employee = Object.values(employees).find((emp) => emp.id === row.userId);
                const _currentContract = _employee?.contracts?.find((cont) => cont.id === row.contractId);
                const _locality = localities?.find((loc) => loc?.id === row.localityId);
                const pos = positions?.find((p) => p.id === row.positionId);
                const details = [
                    (0, util_1.isValue)(pos) ? react_1.default.createElement(_ui_1.Position, { pos: pos }) : null,
                    (0, util_1.isValue)(contractType?.name) && (0, util_1.isValue)(contractType)
                        ? `${contractType.name}${(0, util_1.isValue)(_currentContract?.contractId) && (0, util_1.isDefined)(_currentContract) ? ` (${_currentContract.contractId})` : ''}`
                        : null,
                    (0, util_1.isValue)(_locality) && (0, util_1.isValue)(_locality.name)
                        ? `${(0, util_1.isValue)(_locality.shortName) ? `(${_locality.shortName}) ` : ''}${_locality.name}`
                        : null,
                    row.note,
                ]
                    .filter(util_1.isValue)
                    .map((elem) => ({ elem, id: (0, uuid_1.v4)() }));
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { style: DETAILS_CONTAINER_STYLE }, details.map((elem, index) => (react_1.default.createElement(react_1.default.Fragment, { key: elem.id },
                        elem.elem,
                        index < details.length - 1 ? react_1.default.createElement("span", null, "\u00A0-\u00A0") : null))))));
            },
            rowToStr: (row) => {
                const _contractType = row.contractType;
                const contractType = contractTypes?.find((type) => type.id === _contractType);
                const _employee = Object.values(employees).find((emp) => emp.id === row.userId);
                const _currentContract = _employee?.contracts?.find((cont) => cont.id === row.contractId);
                const pos = positions?.find((p) => p.id === row.positionId);
                const _locality = localities?.find((loc) => loc?.id === row.localityId);
                const details = [
                    (0, util_1.isValue)(pos) ? pos.name : null,
                    (0, util_1.isValue)(contractType?.name) && (0, util_1.isValue)(contractType)
                        ? `${contractType.name}${(0, util_1.isValue)(_currentContract?.contractId) && (0, util_1.isDefined)(_currentContract) ? `(${_currentContract.contractId})` : ''}`
                        : null,
                    (0, util_1.isValue)(_locality) && (0, util_1.isValue)(_locality.name)
                        ? `${(0, util_1.isValue)(_locality.shortName) ? `(${_locality.shortName}) ` : ''}${_locality.name}`
                        : null,
                    row.note,
                ].filter(util_1.isValue);
                return details.join(' - ');
            },
        },
    ]).filter(util_1.isValue);
    return (react_1.default.createElement("div", { className: 'confirm-record-list-wrapper' },
        react_1.default.createElement(_ui_1.Table, { maxHeight: '22rem', type: _ui_1.Table.TYPES.FILL, tableName: 'confirmModalRecordsListTable', showSelection: false, tableConfig: tableConfig, rows: records, showActionBar: false, size: _ui_1.Table.SIZE.SLIM, pagination: false })));
};
exports.default = RecordsList;
